/** "1 stroke", "12 strokes". */
export function formatStrokeCount(strokeCount: number): string {
  return `${strokeCount} ${strokeCount === 1 ? "stroke" : "strokes"}`;
}
